import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LayoutUtilsService } from 'src/app/core/layout-utils.service';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { Artikel } from '../../store/models/artikel';
import { Warenkorb } from '../../store/models/warenkorb';
import { Webshops } from '../../store/models/webshops';
import { WarenkorbsService } from '../../webshops/warenkorbs/shared/warenkorbs.service';
import { ArtikelQuickView1Component } from '../artikel-quick-view1/artikel-quick-view1.component';
import { ArtikelsService } from '../shared/artikels.service';

class SelectedArtikel {
    artikel: any;
    menge: number;
    isMatrixArtikel: boolean;
}

@Component({
    selector: 'kkis-app-webshop-aktions-artikel',
    templateUrl: './aktions-artikel.component.html',
    styleUrls: ['./aktions-artikel.component.scss']
})
export class AktionsArtikelComponent implements OnInit {

    // Output
    @Output()
    numberWarenkorbItems: EventEmitter<number> = new EventEmitter<number>();

    // User
    loggedInUser: Webshops.ILoggedInUser;

    // Warenkorb
    warenkorb: Warenkorb.IWarenkorbDto;

    // Artikel
    artikel: Artikel.IArtikelDto[];
    artikeloptions: Artikel.IArtikelOptionsDto;   

    responsiveOptions;

    // (from local <<NOT>> FROM DATABASE)
    imgDummy: string = "assets/media/svg/files/no-image.svg";

    // Dialog
    dialogWidth: string;
    dialogHeight: string;

    // Utils
    isLoading: boolean = true;
    isLoggedIn: boolean = false;
    isSubmitted: boolean = false;

    constructor(
        private dialog: MatDialog,
        private layoutUtilsService: LayoutUtilsService,
        private authService: AuthService,
        private warenkorbsService: WarenkorbsService,
        private artikelsService: ArtikelsService,
    ) { }

    ngOnInit(): void {

        var w = this.layoutUtilsService.getBootstrapClass();
        switch(w) {
            case 0:
            case 1: {
                this.dialogWidth = "95%";
                this.dialogHeight = "95%";
                break;
            }
            case 2: {
                this.dialogWidth = "80%";
                this.dialogHeight = "80%";
                break;
            }
            case 3: {
                this.dialogWidth = "80%";
                this.dialogHeight = "80%";
                break;
            }
            default: {
                this.dialogWidth = "80%";
                this.dialogHeight = "80%";
                break;
            }
        }


        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 3,
                numScroll: 3
            },
            {
                breakpoint: '768px',
                numVisible: 2,
                numScroll: 2
            },
            {
                breakpoint: '560px',
                numVisible: 1,
                numScroll: 1
            }
        ];

        this.artikelsService.getListAktionsartikelAsync().subscribe(res => {
            
            $('kkis-app-webshop-info-section1').hide();

            if (res) {
                //Sind Aktionsartikel vorhanden? --> ganze Section einblenden
                if (res.length > 0) {
                    $('kkis-app-webshop-info-section1').show();
                }
                this.artikel = res;
                this.isLoading = false;


/* Test
                //ArtikelOptionen
                this.display_artnr = res.artikelOptions.display_artnr;
                this.display_herstellernr = res.artikelOptions.display_herstellernr;
                this.display_mcode1 = res.artikelOptions.display_mcode1;
                this.display_mcode2 = res.artikelOptions.display_mcode2;
                this.lbl_mcode1 = res.artikelOptions.lbl_mcode1;
                this.lbl_mcode2 = res.artikelOptions.lbl_mcode2;

                this.artikeloptions = res.artikelOptions;
                */

            } else {
                this.isLoading = false;
            }
        });

        this.authService.isAuthenticated$.subscribe(x => {
            this.isLoggedIn = x;
        });

    }

    onOpenArtikelQuickView(artikel: Artikel.IArtikelDto) {
        console.log("ASD"); 
        const dialogRef = this.dialog.open(ArtikelQuickView1Component, {
            width: this.dialogWidth,
            disableClose: true,
            autoFocus: true,
            data: {
                artikel: artikel,
                artikeloptions: this.artikeloptions
            }
        });

        dialogRef.afterClosed().subscribe((res: SelectedArtikel) => {
            // add to warenkorb if menge > 0
            if (res.menge > 0) {
                this.onAddToWarenkorb(res.artikel, res.menge, res.isMatrixArtikel)
            }
        });
  
    }

    onAddToWarenkorb(artikel, menge: number, isMatrixArtikel: boolean = false) {
        if (this.isLoggedIn) {
            this.isSubmitted = true;

            let newPosition = {} as Warenkorb.IAddPositionDto;
    
            newPosition.artikelKennung = artikel.id;
            newPosition.menge = menge;
            newPosition.isMatrixArtikel = isMatrixArtikel;
    
            this.warenkorbsService.addPosition(newPosition).subscribe(res => {
                if (res != null) 
                {
                    
                    this.numberWarenkorbItems.emit(res.warenkorbPositionen.length);
                }
            });
        } else {
            const _title: string = "Anmelden";
            const _description: string = "Sie sind noch nicht angemeldet. Jetzt anmelden?";
    
            this.layoutUtilsService.qwertDialog(_title, _description, 'question', true, true, 'Anmelden').then(res => {
                if (res.dismiss) {
                    return;
                }

                this.authService.login();
                return;

            });
        }
    }

}
